<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <h4 class="card-title">Data Table</h4>
            <button v-b-modal.modal-user class="btn btn-success" @click="resetModal"><i class="bx bxs-plus-square mr-1"></i> Add Voucher</button>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search Code..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <vue-good-table
                  mode="remote"
                  :pagination-options="{
                    enabled: false,
                    mode: 'pages',
                    perPage: perPage,
                    position: 'bottom',
                    perPageDropdown: [5, 10],
                    dropdownAllowAll: false,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                  :totalRows="totalRows"
                  :rows="VoucherData"
                  :columns="columns"
                  :sort-options="{
                    enabled: false,
                    initialSortBy: {field: 'id', type: 'desc'}
                  }"
              >
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field == 'btn'">
                    <b-button pill size="sm" @click="setModalVoucher(props.row)" v-b-modal.modal-user>Edit</b-button>
                    <b-button pill variant="danger" size="sm" @click="deleteVoucher(props.row)">Delete</b-button>
                  </div>
                </template>
              </vue-good-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <b-modal id="modal-user" :title="modalTitle" button-size="sm">
              <b-input-group label="Code:" class="mt-3">
                <b-form-input type="text" v-model="voucherPayload.code" placeholder="Input Code"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info" @click="checkAvailableVoucher">Check</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-group label="Discount Type:" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="voucherPayload.discount_type" :aria-describedby="ariaDescribedby" name="some-radios" value="price">Price</b-form-radio>
                <b-form-radio v-model="voucherPayload.discount_type" :aria-describedby="ariaDescribedby" name="some-radios" value="percentage">Percentage</b-form-radio>
              </b-form-group>
              <label>Discount Price:</label>
              <b-form-input v-model="voucherPayload.discount_price"></b-form-input>
              <b-form-group
                  label="Single Use:"
                  name="flavour-2"
                  label-cols-sm="2"
              >
                <b-form-checkbox
                    class="mt-2"
                    v-model="voucherPayload.is_single_use" :value="true">Active</b-form-checkbox>
              </b-form-group>
              <b-form-group
                  label="Active:"
                  name="flavour-2"
                  label-cols-sm="2"
              >
                <b-form-checkbox
                    class="mt-2"
                    v-model="voucherPayload.active" :value="true">Active</b-form-checkbox>
              </b-form-group>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button v-if="mode === 'insert'" variant="primary" :disabled="loadingUpdate" size="sm" @click="insertVoucher">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
                <b-button v-else variant="primary" :disabled="loadingUpdate" size="sm" @click="updateVoucher">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";
import {multiselectMixin, Multiselect} from 'vue-multiselect'

export default {
  name: "index",
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Voucher",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Voucher",
          active: true
        }
      ],
      voucherPayload: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      VoucherData: [],
      columns: [
        { field: "id", label: "ID" },
        { field: "code", label: "Code" },
        { field: "discount_type", label: "Discount Type" },
        { field: "discount_price", label: "Discount" },
        { field: "is_single_use", label: "Single Use" },
        { field: "active", label: "Active" },
        { field: "btn", label: "Action" }
      ],
      modalTitle: "Tambah Voucher",
      searchText: "",
      mode: "",
      loadingUpdate: false,
      isPartnership: "",
      partnerData: [],
      voucherChecked: false
    }
  },
  methods: {
    fetchVoucherData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallVoucherData(params)
    },
    updateVoucher() {
      axios.put("/api/voucher/"+this.voucherPayload.id, this.voucherPayload).then(resp => {
        const { data } = resp.data
        Swal.fire('Sukses')
        this.$bvModal.hide('modal-user')
        this.fetchVoucherData()
        this.loadingUpdate = false
      });
    },
    httpCallVoucherData(params) {
      axios.get("/api/voucher?"+params)
          .then(resp => {
            const { data, total } = resp.data
            this.totalRows = total
            this.VoucherData = data
            this.isFetched = true
          });
    },
    resetModal() {
      this.mode = 'insert'
      this.voucherPayload = {}
      this.isPartnership = ''
      this.modalTitle = 'Tambah Voucher'
    },
    insertVoucher() {
      this.loadingUpdate = true
      axios.post("/api/voucher", this.voucherPayload).then(resp => {
        const { message } = resp.data
        if (message !== 'success') {
          Swal.fire({
            icon: 'error',
            title: '',
            text: message,
          })
        } else {
          Swal.fire('Sukses')
          this.$bvModal.hide('modal-user')
          this.fetchVoucherData()
        }
        this.loadingUpdate = false
      }).catch(err => {
        const {data} = err.response
        console.log(data)
        Swal.fire(data.message)
        this.$bvModal.hide('modal-user')
        this.loadingUpdate = false
      });
    },

    setModalVoucher(Voucher) {
      this.mode = 'edit'
      this.voucherPayload = Object.assign({}, Voucher)
      this.modalTitle = 'Edit Voucher'
    },
    deleteVoucher(rowData) {
      Swal.fire({
        title: "Yakin, hapus data ini",
        text: name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Iya, hapus!"
      }).then(result => {
        if (result.value) {
          axios.delete("/api/voucher/"+rowData.id).then(resp => {
            const { data } = resp.data
            Swal.fire('Sukses')
            this.fetchVoucherData()
          });
        }
      });
    },
    checkAvailableVoucher() {
      this.voucherChecked = true
      axios.get("/api/voucher/code/"+this.voucherPayload.code)
          .then(resp => {
            const { data } = resp.data
            Swal.fire("Voucher is not available")
            this.voucherChecked = false
            this.voucherPayload.code = ''
          });
    }
  },
  mounted() {
    this.fetchVoucherData()
  }
}
</script>

<style scoped>

</style>